const VUEX_PREFS_KEY = "admin_ui_prefs"

const initLang = (() => {
    let lang = JSON.parse(window.localStorage.getItem(VUEX_PREFS_KEY))
    if(lang === null){
        return process.env.VUE_APP_I18N_LOCALE
    }else {
        return lang.lang_code
    }
})()

const state = {
    lang: initLang
}

const getters = {
    langCode: state => {
        return state.lang
    }
}

const actions = {
    changeLanguage ({ commit }, payload) {
        commit('changeLanguage', payload)
    }
}

const mutations = {
    changeLanguage (state, payload) {
        const lang_prefs = {
            lang_code: payload
        }
        window.localStorage.setItem(VUEX_PREFS_KEY, JSON.stringify(lang_prefs));
        state.lang = payload
    }
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
